import React, { useState, useRef, useEffect } from "react";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Overlay from "react-bootstrap/Overlay";

import SocialShareButton from "./SocialShareButton";
import { parseDate, getScreenSize, sizeEqualOrLessThan } from "utils/helpers";
import { colors } from "@utils/styles";
export default function CiteButton(props) {
	const [show, setShow] = useState(false);
	const [copyConfirm, setCopyConfirm] = useState("");
	const targetRef = useRef(null);
	const [citationText, setCitationText] = useState("");
	const citationTextRef = useRef(null);

	const { article, gtmEvent = () => {} } = props;

	const { sys, fields } = article;

	let {
		doiPrefix = {},
		doiSuffix,
		author = [],
		journalEdition = {},
		endPage,
		abstract,
		publicationDate,
		startPage,
		title,
	} = fields;

	const { journalEditionVolume, journalEditionIssue } = journalEdition?.fields || {};
	const { dayOfWeek, dayOfMonth, month, year } = parseDate(publicationDate);

	let moreThanThreeAuthors = false;
	if (author.length > 3) {
		moreThanThreeAuthors = true;
		author = author.slice(0, 3);
	}
	let authors = author.length ? author.map((a) => a.fields.citationName).join(", ") : "";
	if (moreThanThreeAuthors) {
		authors += ", et al";
	}

	const smOrSmaller = sizeEqualOrLessThan("sm");

	const handleClick = () => {
		setShow(!show);
	};

	useEffect(() => {
		if (!citationTextRef.current) return;
		if (show) {
			var sel, range;
			var el = citationTextRef.current; //get element id
			setCopyConfirm("");
			setCitationText(el.innerText);

			if (window.getSelection && document.createRange) {
				//Browser compatibility
				sel = window.getSelection();

				if (sel.toString() == "") {
					//no text selection
					window.setTimeout(function () {
						range = document.createRange(); //range object
						range.selectNodeContents(el); //sets Range
						sel.removeAllRanges(); //remove all ranges from selection
						sel.addRange(range); //add Range to a Selection.
					}, 1);
				}
			} else if (document.selection) {
				//older ie
				sel = document.selection.createRange();
				if (sel.text == "") {
					//no text selection
					range = document.body.createTextRange(); //Creates TextRange object
					range.moveToElementText(el); //sets Range
					range.select(); //make selection.
				}
			}
		}
		if (!show) {
			setCopyConfirm("");
		}
	}, [show, citationTextRef.current]);

	if (!doiSuffix || !doiPrefix?.prefix || !journalEdition?.fields?.journal?.fields?.title) {
		return <></>; //only show for doi articles
	}
	return (
		<>
			<div ref={targetRef}>
				<SocialShareButton
					onClick={handleClick}
					smOrSmaller={smOrSmaller}
					text="Cite"
					icon={faCopy}
					// loading={loadingBookmarks}
					gtmEvent={gtmEvent}
				/>
			</div>

			<Overlay target={targetRef.current} show={show} placement="right">
				{({
					placement: _placement,
					arrowProps: _arrowProps,
					show: _show,
					popper: _popper,
					hasDoneInitialMeasure: _hasDoneInitialMeasure,
					...props
				}) => (
					<div
						className="overlay-container radius-5px boxShadow"
						{...props}
						style={{
							...props.style,
						}}
					>
						<div className="copy-close-btn-container">
							<FontAwesomeIcon
								onClick={() => setShow(false)}
								className="clickable"
								width={"1.7em"}
								height={"1.7em"}
								color={colors.red}
								icon={faXmark}
							/>
							{"  "}
							<CopyToClipboard text={citationText} onCopy={() => setCopyConfirm("Copied to clipboard")}>
								<FontAwesomeIcon
									className="clickable"
									style={{ marginLeft: "1em", paddingBottom: "0.2em" }}
									width={"1.7em"}
									height={"1.7em"}
									color={colors.mediumGray}
									icon={faCopy}
								/>
							</CopyToClipboard>
							<span className="select-none">{copyConfirm}</span>
						</div>
						{journalEdition?.fields?.journal?.fields?.title && doiPrefix?.prefix && (
							<span ref={citationTextRef}>
								{authors}. {title}.{" "}
								<span className="fst-italic">
									{journalEdition?.fields?.journal?.fields?.title + "."}
								</span>{" "}
								{`(${year});`}
								{journalEditionVolume}
								{/* {`(${journalEditionIssue})${startPage}/${endPage}`}. doi: {doiPrefix.prefix}/{doiSuffix} */}
								{`(${journalEditionIssue})${startPage}/${endPage}`}.{" "}
								<a
									href={`https://doi.org/${doiPrefix.prefix}/${doiSuffix}`}
								>{`https://doi.org/${doiPrefix.prefix}/${doiSuffix}`}</a>
							</span>
						)}
					</div>
				)}
			</Overlay>
			<style jsx="true">{`
				.overlay-container {
					border: 2px solid ${colors.yellow};
					position: absolute;
					background: ${colors.white};
					color: ${colors.lightBrown};
					max-width: 600px;
					padding: 2em 1em 1em 1em;
				}

				.copy-close-btn-container {
					position: absolute;
					top: 0.3em;
				}
				.select-none {
					user-select: none;
				}
			`}</style>
		</>
	);
}
